<div class="row">
  <div class="col-md-6 add-button-wrapper">
    <button class="add-button-text" routerLink="/seller/new-products/claim">
      {{ "Sellers.Products.AddClaim" | translate }}
    </button>
    <button
      routerLink="/seller/new-products/claim"
      id="addButton"
      class="add-button"
    >
      +
    </button>
  </div>

  <div class="col-md-6 add-button-wrapper">
    <button
      class="add-button-text"
      [routerLink]="['/seller/new-bulk']"
      [queryParams]="{ type: 'claims' }"
    >
      {{ "Add_Bulk" | translate }}
    </button>
    <button
      [routerLink]="['/seller/new-bulk']"
      [queryParams]="{ type: 'claims' }"
      id="addButton"
      class="add-button"
    >
      +
    </button>
  </div>
</div>
